import injector from 'vue-inject'

/**
 * Service used for dashboards / tabs CRUD
 */
class DashboardService {
  constructor(axios, apiRoot) {
    this.axios = axios
    this.apiRoot = apiRoot
  }

  /**
   * Init first dashboard for a new user
   * @param {*} userIDForm
   */
  async initDashboard(userIDForm) {
    const url = `${this.apiRoot}/dashboard/init`
    return this.axios.post(url, userIDForm).then(response => response.data)
  }

  async getUserTabs(userId) {
    const url = `${this.apiRoot}/dashboard/tabs/user/${userId}`
    return this.axios.get(url).then(response => response.data)
  }

  /**
   * Get dashboard's charts according to his ID
   * @param {} dashboardId
   */
  async getDashboard(dashboardId) {
    const url = `${this.apiRoot}/dashboard/${dashboardId}`
    return this.axios.get(url).then(response => response.data)
  }

  /**
   * Create a new dashboard
   * @param {*} dashboardForm
   */
  async createDashboard(dashboardForm) {
    const url = `${this.apiRoot}/dashboard/create`
    return this.axios.post(url, dashboardForm).then(response => response.data)
  }

  /**
   * Update a dashboard
   * @param {*} dashboardForm
   */
  async updateDashboard(dashboardForm) {
    const url = `${this.apiRoot}/dashboard/update`
    return this.axios.post(url, dashboardForm).then(response => response.data)
  }

  /**
   * Update dashboard ranks
   * @param {*} dashboardForm
   */
  async updateDashboardRanks(tab) {
    const url = `${this.apiRoot}/dashboard/ranks/update`
    return this.axios.post(url, tab).then(response => response.data)
  }

  /**
   * Delete a dashboard
   * @param {*} dashboardForm
   */
  async deleteDashboard(dashboardForm) {
    const url = `${this.apiRoot}/dashboard/delete`
    return this.axios.delete(url, { data: dashboardForm }).then(response => response.data)
  }

  /**
   *
   * @param {*} dashboardForm
   */
  async duplicateDashboard(dashboardForm) {
    const url = `${this.apiRoot}/dashboard/duplicate`
    return this.axios.post(url, dashboardForm).then(response => response.data)
  }

  /**
   * Share a dashboard to users
   * @param {*} dashboardId
   * @param {*} users
   */
  async shareDashboard(dashboardId, users, sitesPreset) {
    const url = `${this.apiRoot}/dashboard/share`
    const form = {
      dashboard_id: dashboardId,
      users_id: users,
      sites_preset: sitesPreset || [],
    }
    return this.axios.post(url, form).then(response => response.data)
  }

  /**
   * Create a new chart into a dashboard
   * @param {*} chartForm
   */
  async addNewChart(chartForm) {
    const url = `${this.apiRoot}/dashboard/chart/create`
    return this.axios.post(url, chartForm).then(response => response.data)
  }

  /**
   * Update chart
   * @param {*} chartForm
   */
  async updateChart(chartForm) {
    const url = `${this.apiRoot}/dashboard/chart/update`
    return this.axios.post(url, chartForm).then(response => response.data)
  }

  /**
   * Delete chart
   * @param {*} chartForm
   */
  async deleteChart(chartId) {
    const url = `${this.apiRoot}/dashboard/chart/delete`
    const form = { id: chartId }
    return this.axios.delete(url, { data: form }).then(response => response.data)
  }

  /**
   * Update chart rows
   * @param {*} dashboard
   */
  async updateChartsRows(dashboard) {
    const url = `${this.apiRoot}/dashboard/charts/ranks/update`
    return this.axios.post(url, dashboard).then(response => response.data)
  }

  /**
   * Create a new tab
   * @param {*} tabForm
   */
  async createTab(tabForm) {
    const url = `${this.apiRoot}/dashboard/tab/create`
    return this.axios.post(url, tabForm).then(response => response.data)
  }

  /**
   * Update tab
   * @param {*} tabForm
   */
  async updateTab(tabForm) {
    const url = `${this.apiRoot}/dashboard/tab/update`
    return this.axios.post(url, tabForm).then(response => response.data)
  }

  /**
   * Delete tab
   * @param {*} tabForm
   */
  async deleteTab(tabForm) {
    const url = `${this.apiRoot}/dashboard/tab/delete`
    return this.axios.delete(url, { data: tabForm }).then(response => response.data)
  }

  /**
   * Duplicate tab
   * @param {*} tabForm
   */
  async duplicateTab(tabForm) {
    const url = `${this.apiRoot}/dashboard/tab/duplicate`
    return this.axios.post(url, tabForm).then(response => response.data)
  }

  /**
   * Share a tab to users
   * @param {*} tabId
   * @param {*} users
   * @param {*} rank
   */
  async shareTab(tabId, users, rank, sitesPreset) {
    const url = `${this.apiRoot}/dashboard/tab/share`
    const form = {
      tab_id: tabId,
      users_id: users,
      rank: rank,
      sites_preset: sitesPreset || [],
    }
    return this.axios.post(url, form).then(response => response.data)
  }

  /**
   * Update tabs order
   * @param {*} tabs
   */
  async updateTabsOrder(tabs) {
    const url = `${this.apiRoot}/dashboard/tab/order/update`
    return this.axios.post(url, tabs).then(response => response.data)
  }

  /**
   * Update tab ranks into his tab
   * @param {*} dashboardForm
   */
  async updateTabRanks(user) {
    const url = `${this.apiRoot}/dashboard/tab/ranks/update`
    return this.axios.post(url, { user: user }).then(response => response.data)
  }
}

injector.service('dashboardService', ['axios', 'apiRoot'], DashboardService)
